const ftpClients = ['FTP', 'SFTP'];

module.exports = {
    ftpClients
};